import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/common/Header';
import UploadStep from '../steps/UploadStep';
import SignalStatusStep from '../steps/SignalStatusStep';
import MetadataStep from '../steps/MetadataStep';

export default function Commission() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [ocrData, setOcrData] = useState({ serialNumber: '', eui: '', imageUrl: '' });
  const locationState = useLocation();
  const latLon = locationState.state?.location;

  useEffect(() => {
    if (latLon) {
      console.log('Latitude:', latLon.lat, 'Longitude:', latLon.lon);
    }
  }, [latLon]);

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <UploadStep
            onNext={() => setStep(2)}
            onBack={() => navigate('/')}
            setOcrData={setOcrData}
            ocrData={ocrData}
          />
        );
      case 2:
        return (
          <SignalStatusStep
            setOcrData={setOcrData}
            ocrData={ocrData}
            onBack={() => setStep(1)}
            onNext={() => setStep(3)}
          />
        );
      case 3:
        return (
          <MetadataStep
            ocrData={ocrData}
            onBack={() => setStep(2)}
            location={latLon}
            onNext={(finalData) =>
              navigate('/success', { state: { ...ocrData, ...finalData } })
            }
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-app text-gray-800">
      <Header location={latLon} />
      <main className="max-w-xl mx-auto px-4 py-10">
        {/* Card container with consistent height */}
        <div className="bg-white rounded-lg shadow p-6 min-h-[500px] flex flex-col">
          {/* Progress bar */}
          <div className="mb-6">
            <div className="text-sm text-gray-600 mb-1">Step {step} of 3</div>
            <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
              <div
                className="h-full bg-primary transition-all duration-300"
                style={{ width: `${(step / 3) * 100}%` }}
              />
            </div>
          </div>

          {/* Step content */}
          {renderStep()}
        </div>
      </main>
    </div>
  );
}
